<template>
    <div>
        <CFTitle title="26. Buget – Amplasament"></CFTitle>
        <div class="buget-amplasament">
            <M3Warn v-if="locations.length < 1" type="red-warn" text="Te rugăm să adaugi mai întâi date despre localizarea proiectului în"><template v-slot:link><router-link to="/aplicatii/m3-sketch/proiectul-meu" style="margin-left: 10px; font-weight: 600">Proiectul meu</router-link></template></M3Warn>
            <table v-if="locations.length > 0">
                <thead>
                    <tr>
                        <th class="table-head blue-head" style="width: 12.5%"><p>Cod regiune</p></th>
                        <th class="table-head blue-head" style="width: 12.5%"><p>Regiune</p></th>
                        <th class="table-head blue-head" style="width: 12.5%"><p>Cod județ</p></th>
                        <th class="table-head blue-head" style="width: 12.5%"><p>Județ</p></th>
                        <th class="table-head blue-head" style="width: 12.5%"><p>Buget eligibil</p></th>
                        <th class="table-head blue-head" style="width: 12.5%"><p>% din totalul bugetului eligibil</p></th>
                        <th class="table-head blue-head" style="width: 12.5%"><p>Ajutor de stat</p></th>
                        <th class="table-head blue-head" style="width: 12.5%"><p>% din totalul ajutorului de stat</p></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(location, key) in locations" :key="key">
                        <td style="width: 12.5%">{{ location.regionCode }}</td>
                        <td style="width: 12.5%">{{ location.regionName }}</td>
                        <td style="width: 12.5%">{{ location.stateCode }}</td>
                        <td style="width: 12.5%">{{ location.stateName }}</td>
                        <td v-if="key === 0" style="width: 12.5%" :rowspan="locations.length"> {{ bugetData && bugetData.total_eligibil_proiect ? bugetData.total_eligibil_proiect.RON : '-' }} LEI</td>
                        <td v-if="key === 0" style="width: 12.5%" :rowspan="locations.length">100%</td>
                        <td v-if="key === 0" style="width: 12.5%" :rowspan="locations.length">{{ bugetData && bugetData.nerambursabil ? bugetData.nerambursabil.RON : '-' }} LEI</td>
                        <td v-if="key === 0" style="width: 12.5%" :rowspan="locations.length">{{ bugetData && bugetData.nerambursabil ? bugetData.nerambursabil.procent + '%' : '-' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import CFTitle from "./CFTitle";
    import M3Warn from "../M3Warn";
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';

    export default {
        components: {
            CFTitle,
            M3Warn
        },
        props: {
            data: {
                type: Object,
                default: null
            },
            bugetData: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                states: [],
                locations: [],
            }
        },
        watch: {
            states: {
                handler: function () {
                    this.checkLocations();
                },
                deep:true
            }
        },
        mounted() {
            axios.get(api.API_ROOT + '/states-and-regions/RO')
                .then( response => {
                    this.states = response.data
                })
            if(this.locations.length > 0) {
                this.$store.dispatch('finantare/addToProgress', 'Buget - Amplasament')
            }
            this.checkLocations();
        },
        methods: {
            checkLocations(){
                if(this.data && this.data.m3_project && this.data.m3_project.location_address){
                    if(this.states)
                    {
                        this.locations = [];
                        this.data.m3_project.location_address.forEach(location => {
                            if(this.states[location.state])
                                this.locations.push(
                                    this.states[location.state]
                                )
                        });
                        if(this.locations.length > 0) {
                            this.$store.dispatch('finantare/addToProgress', 'Buget - Amplasament')
                        }
                    }
                }
            }
        }
    }
</script>
<style scoped>
.buget-amplasament{
  margin-top: 40px;
}
table, th, td {
  border: 1px solid #979696;
  width: 100%;
  height: 100%;
  text-align: center;
}
td{
  font-size: 14px;
  padding: 5px;
}
.padding-td tr td:first-child{
  padding: 10px;
}
.table-head p{
  font-size: 14px;
  text-align: center;
  font-weight: 700;
  text-transform: uppercase;
}
.table-head{
  padding: 10px;
  border: 1px solid #979696;
  border-bottom: 0;
  position: relative;
}
.blue-head{
  background: #bdd6ee;
}
</style>
